import { AnnualClockApi } from "api-client";
import store from "config/store";
import { Dispatch } from "redux";
import { getAuthConfiguration } from "utils/getAuthConfiguration";

import { ACTIONS } from "./types";

export const getAnnualClock = () => async (dispatch: Dispatch) => {
    const apiBaseUrl = store.getState().appConfiguration.apiBaseUrl;
    const annualClockApi = new AnnualClockApi(getAuthConfiguration(apiBaseUrl));
    try {
        dispatch({
            type: ACTIONS.GET_ANNUAL_CLOCK_REQUEST,
        });
        const res = await annualClockApi.getAnnualClockApiAnnualClockGet();
        dispatch({
            type: ACTIONS.GET_ANNUAL_CLOCK_SUCCESS,
            payload: res,
        });
    } catch (e) {
        dispatch({
            type: ACTIONS.GET_ANNUAL_CLOCK_FAILURE,
        });
        throw e;
    }
};
